(() => {
  const dismissalKey = 'soleplay:nike-one-piece:invitation-dismissed';
  if (customElements.get('nop-draw-popup')) return;

  class DrawPopup extends HTMLElement {
    isDrawDestination() {
      const path = location.pathname.replace(/\/+$/, '');
      if (/(^|\/)pages\/nike-one-piece$/.test(path)) return true;
      const href = this.querySelector('[data-enter]')?.getAttribute('href');
      if (!href) return false;
      try {
        const destination = new URL(href, location.href);
        return destination.origin === location.origin && destination.pathname.replace(/\/+$/, '') === path;
      } catch { return false; }
    }

    connectedCallback() {
      if (this.isDrawDestination()) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function' || this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelectorAll('[data-dismiss]').forEach(button => button.addEventListener('click', () => this.dismiss(), options));
      this.querySelector('[data-enter]')?.addEventListener('click', () => this.dismiss(), options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, options);
      this.dialog.addEventListener('close', () => this.restoreScroll(), options);
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dismiss();
      }, options);
      this.editor = this.dataset.editor === 'true';
      if (this.editor) {
        if (this.dataset.editorPreview === 'true') this.show();
        return;
      }
      try { if (sessionStorage.getItem(dismissalKey) === '1') return; } catch { /* Private browsing must not break the page. */ }
      const seconds = Number(this.dataset.delay);
      this.timer = setTimeout(() => this.show(), (Number.isFinite(seconds) ? Math.max(4, seconds) : 10) * 1000);
    }

    show() {
      if (!this.isConnected || this.isDrawDestination() || this.dialog.open) return;
      // Do not interrupt an open cart, search drawer, or another modal.
      if (!this.editor && document.querySelector('dialog[open], [open] [role="dialog"], body.drawer--is-open, html.overflow-hidden, body.overflow-hidden')) return;
      this.dialog.showModal();
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.scrollLocked = true;
    }

    dismiss() {
      if (!this.editor) { try { sessionStorage.setItem(dismissalKey, '1'); } catch { /* Optional suppression only. */ } }
      this.dialog.close();
      this.restoreScroll();
    }

    restoreScroll() {
      if (!this.scrollLocked) return;
      document.documentElement.style.overflow = this.previousOverflow;
      this.scrollLocked = false;
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
      this.events = null;
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll();
    }
  }
  customElements.define('nop-draw-popup', DrawPopup);
})();
